"use client";

import { MessagePartPrimitive, type TextMessagePartProps } from "@assistant-ui/react";
import { memo } from "react";

const MessageTextImpl = (_props: TextMessagePartProps) => {
  return (
    <p className="ph-no-capture whitespace-pre-line">
      <MessagePartPrimitive.Text component="span" />
      <MessagePartPrimitive.InProgress>
        <span aria-hidden="true">{" ..."}</span>
      </MessagePartPrimitive.InProgress>
    </p>
  );
};

export const MessageText = memo(MessageTextImpl);
